import React from 'react';
import './searchresult.scss';
import  Globals from '../../api' ;
import Rightbar from "../../components/Rightbar/Rightbar";
import ImageConvertionDefault from "../../config";
export default class SearchResult extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
           searchdata : [],
           meta : [] ,
           title : [],
           meta_keywords : [],
           meta_description : [],
           Rightbar : [],
           AdData : []
         };
      }
      getAds(){
        const url= Globals.AdConfig;
                fetch(url)
                .then((res) => res.json())
                .then((data) => {
                  
                    this.setState({
                      AdData : data.AdContents[0].ROS
                    })
                    
                }) 
                
      } 
      getRightbar(){
        const url= Globals.Rightbar_api+"/tamil-news-updates-latest-news";
        fetch(url)
        .then((res) => res.json())
        .then((data) => {
            
            this.setState({
              Rightbar : data.Contents[0]
            })
        })   
      }    
      componentDidMount() {
        let url = window.location.pathname;
        const MainUrl= Globals.language_based_api + url;
        // console.log(HeaderConurl)
        fetch(MainUrl)
        .then((res) => res.json())
        .then((data) => {
            //console.log(data)
            this.setState({
                searchdata :data.Contents[2].tagcontents.Contents.Pages,
                meta : data.Meta ,
                title : data.Title,
                meta_keywords : data.Meta.keywords.Attributes.content,
                meta_description : data.Meta.description.Attributes.content
            })
        })
        this.getRightbar();
        this.getAds();
      }
      
    render() {
        var pageURL = window.location.href;
        var lastURLSegment = pageURL.substr(pageURL.lastIndexOf('/') + 1); 
          let TagContents = this.state.searchdata;
        const SearchListData = TagContents.map((item, i) => 

                <div className="s_article_list_block">
                <div className="s_article_list_cont">
                    <h3><a href={item.Url || item.GalleryUrl || "/wdvideo/"+item.VideoID}>{item.Title || item.GalleryTitle }</a></h3>
                    <time>{item.DateTime}</time>
                </div>
                <div className="s_article_list_img">
                    <img 
                    //src={item.Thumbnail || item.Image}
                    src={ImageConvertionDefault(
                        item.Image || item.Thumbnail, 90, 60
                      )}
                    alt={item.Title}
                        title={item.Title}
                        
                    />
                </div>
            </div>
               
        );
        const handleSearch = () => {
            let searchValue = document.getElementsByClassName("Search_Field")[0].value;
            if(searchValue == "")
            searchValue = "latest";
           // console.log(searchValue); 
            window.location ="/tags/"+ searchValue +"/article";  
        }
        return (
            <>
             {/* <Helmet>
                <title>{this.state.title}</title>
                <meta name="keywords" content={this.state.meta_keywords} />
                <meta name="description" content={this.state.meta_description} />
                </Helmet> */}
                <div className="">

                    <div className="container padding15">
                        <div className="row">
                            <div className="col">
                                <div className="search_block">
                                    <div className="search_form"><input type="text" placeholder="Search on Webdunia" className="Search_Field"/></div>
                                    <div className="search_btn"><a onClick = {handleSearch}><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="#A50404">
                            <path id="search" d="M50.51,48.159l-9.616-9.616A16.843,16.843,0,1,0,38.535,40.9l9.616,9.608a1.665,1.665,0,0,0,2.359-2.351Zm-22.653-6.8a13.506,13.506,0,1,1,13.51-13.5A13.519,13.519,0,0,1,27.857,41.359Z" transform="translate(-11 -11)" />
                        </svg></a></div>
                                </div>

                                <div className="search_result_wrap">
                                    <ul className="search_r_tabs">
                                        <li><a href={pageURL.split('/').slice(0,-1).join('/')+'/article'} className = {(lastURLSegment == "article") ? 'active' : '' }>Articles</a></li> 
                                        <li><a href={pageURL.split('/').slice(0,-1).join('/')+'/video'} className = {(lastURLSegment == "video") ? 'active' : '' }>Videos</a></li>
                                        <li><a href={pageURL.split('/').slice(0,-1).join('/')+'/photogallery'} className = {(lastURLSegment == "photogallery") ? 'active' : '' }>Photos</a></li>

                                     {/* <li className = {(lastURLSegment == "article") ? 'active' : '' }><a href="/astrology-daily-horoscope">Articles</a></li>
                                    <li  className = {(lastURLSegment == "video") ? 'active' : '' }><a href="/astrology-weekly-horoscope">Videos</a></li>
                                    <li  className = {(lastURLSegment == "photo") ? 'active' : '' }><a href="/astrology-monthly-horoscope">Photos</a></li>
                                    */}
                                    </ul>
                                    {SearchListData}
                                    
                                </div>

                            </div>
                            <div className="col right_side_bar">
                                
                            <Rightbar Rightbar={this.state.Rightbar} googleAds = {this.state.AdData}/>
                            </div>
                        </div>
                    </div>

                </div>
            </>

        )
    }
}